/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { onShowSizeChange, itemRender } from '../Pagination';
import BusinessHeader from '../BusinessHeader';
import SidebarAdmin from '../SidebarAdmin';
import { blogimg10, blogimg12, blogimg2, blogimg4, blogimg6, blogimg8, imagesend, pdficon, pdficon3, pdficon4, plusicon, refreshicon, searchnormal } from '../imagepath';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import config from '../../config';
import { toast, ToastContainer } from 'react-toastify';
import PropTypes from 'prop-types';
import 'react-toastify/dist/ReactToastify.css';
import { DatePicker } from 'antd';
import CreatableSelect from 'react-select/creatable';
import moment from 'moment';
import { usePermission } from '../../PermissionContext';

// CustomToast component
const CustomToast = ({ closeToast, onConfirm, doctorId }) => (
  <div style={{ textAlign: "center", position: "relative" }}>
    <p style={{ fontSize: "16px", fontWeight: "bold" }}>
      ⚠️ Are you sure you want to archive this doctor?
    </p>
    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "10px" }}>
      <button
        onClick={() => {
          onConfirm(doctorId);
          closeToast();
        }}
        style={{
          background: "green",
          color: "white",
          border: "none",
          padding: "5px 15px",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        Yes
      </button>
      <button
        onClick={closeToast}
        style={{
          background: "red",
          color: "white",
          border: "none",
          padding: "5px 15px",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        No
      </button>
    </div>
    <button
      onClick={closeToast}
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        background: "transparent",
        border: "none",
        fontSize: "16px",
        cursor: "pointer",
      }}
    >
      ✕
    </button>
  </div>
);

CustomToast.propTypes = {
  closeToast: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  doctorId: PropTypes.string.isRequired,
};

const DoctorList = () => {
  const { permissions } = usePermission();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [formData, setFormData] = useState({
    full_doctor_name: '',
    education: '',
    email: '',
    phone: '',
    adhar_number: '',
    pan_number: '',
    department: [],
    department_names: '',
    joining_date: '',
    profile_image: null,
    doctor_id: '',
  });
  const [filePreview, setFilePreview] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [showParentDeptSelector, setShowParentDeptSelector] = useState(false);
  const [newDeptName, setNewDeptName] = useState('');
  const [potentialParentDept, setPotentialParentDept] = useState(null);
  const [currentInputValue, setCurrentInputValue] = useState('');

  // Permission checks
  const hasViewAllPermission = permissions?.view_doctors_list_all === 1;
  const hasViewOwnPermission = permissions?.view_doctors_list_own === 1;
  const hasArchivePermission = permissions?.add_archive_doctor === 1;
  const hasViewPermission = hasViewAllPermission || hasViewOwnPermission;

  // Debugging permissions
  useEffect(() => {
    console.log("Permissions in DoctorList:", permissions);
    console.log("Type of permissions:", typeof permissions);
    console.log("Is permissions an array?", Array.isArray(permissions));
    console.log("Has view_doctors_list_all?", permissions?.view_doctors_list_all === 1);
    console.log("Has view_doctors_list_own?", permissions?.view_doctors_list_own === 1);
    console.log("Has add_archive_doctor?", permissions?.add_archive_doctor === 1);
    console.log("Has add_department?", permissions?.add_department === 1);
  }, [permissions]);

  // Debugging departments
  useEffect(() => {
    console.log('Departments state:', JSON.stringify(departments, null, 2));
  }, [departments]);

  // Get flat list of all departments
  const getAllDepartmentsFlat = (depts) => {
    return depts.flatMap(dept => [
      dept,
      ...(dept.children ? getAllDepartmentsFlat(dept.children) : []),
    ]);
  };

  // Row selection
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Fetch departments
  const fetchDepartments = async () => {
    const businessId = localStorage.getItem('BusinessID');
    if (!businessId) {
      toast.error('Business ID is missing.', {
        position: "top-center",
        toastId: "business-id-error",
      });
      return false;
    }
    try {
      const response = await fetch(`${config.API_URL}get_departments.php?business_id=${businessId}`);
      const data = await response.json();

      if (Array.isArray(data)) {
        setDepartments(data);
        return true;
      } else {
        console.error('Unexpected response format:', data);
        toast.error('Unexpected response format from server.', {
          position: "top-center",
          toastId: "fetch-error",
        });
        return false;
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
      toast.error('Error fetching departments.', {
        position: "top-center",
        toastId: "fetch-network-error",
      });
      return false;
    }
  };

  // Add new department
  const addDepartment = async (departmentName, parentId = null) => {
    if (!permissions?.add_department) 
      {
      // toast.error("You do not have permission to add departments.", {
      //   position: "top-center",
      //   toastId: "permission-error",
      // });
      return null;
    }

    const businessId = localStorage.getItem('BusinessID');
    if (!businessId) {
      toast.error('Business ID is missing.', {
        position: "top-center",
        toastId: "business-id-error",
      });
      return null;
    }

    const payload = {
      department_name: departmentName,
      business_id: businessId,
      parent_department_id: parentId || null,
    };

    try {
      const response = await fetch(`${config.API_URL}add_department.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.status === 'success') {
        toast.success('Department added successfully', {
          position: "top-center",
          toastId: "add-department-success",
        });
        const fetchSuccess = await fetchDepartments();
        if (!fetchSuccess) {
          console.error('Failed to refresh departments after adding:', departmentName);
          return null;
        }

        const allDepts = getAllDepartmentsFlat(departments);
        const newDept = allDepts.find(dept =>
          dept.department_name === departmentName &&
          dept.parent_department_id === (parentId || null)
        );

        return newDept || null;
      } else {
        toast.error(result.message || 'Failed to add department', {
          position: "top-center",
          toastId: "add-department-error",
        });
        return null;
      }
    } catch (error) {
      console.error('Error adding department:', error);
      toast.error('Error adding department', {
        position: "top-center",
        toastId: "add-department-network-error",
      });
      return null;
    }
  };

  // Map department IDs to names
  const mapDepartmentNames = (departmentIds) => {
    if (!departmentIds) return 'N/A';

    let ids;
    if (typeof departmentIds === 'string') {
      try {
        ids = JSON.parse(departmentIds);
      } catch (error) {
        ids = departmentIds.split(',').map(id => id.trim());
      }
    } else {
      ids = departmentIds;
    }

    ids = Array.isArray(ids) ? ids : [ids];
    const allDepts = getAllDepartmentsFlat(departments);

    const names = ids
      .map((id) => {
        const dept = allDepts.find((d) => String(d.id) === String(id));
        return dept ? dept.department_name : null;
      })
      .filter((name) => name)
      .join(', ');

    return names || 'N/A';
  };

  // Fetch doctors
  const fetchDoctors = async () => {
    try {
      const businessID = localStorage.getItem('BusinessID');
      const userID = localStorage.getItem('userUUID');
      if (!businessID) {
        toast.error('Business ID is missing.', {
          position: "top-center",
          toastId: "business-id-error",
        });
        return;
      }

      const response = await fetch(`${config.API_URL}get_business_doctors.php?business_id=${businessID}`);
      const result = await response.json();

      if (result.status === 'success') {
        let doctorData = result.doctors;

        // Filter doctors based on permissions
        if (!hasViewAllPermission && hasViewOwnPermission) {
          doctorData = doctorData.filter((doctor) => doctor.created_by === userID);
        }

        const mappedDoctors = doctorData.map((doctor, index) => ({
          id: doctor.doctor_id || index + 1,
          doctor_id: doctor.doctor_id,
          Img: getDoctorImage(index),
          Name: doctor.full_doctor_name || '',
          Department: mapDepartmentNames(doctor.department) || 'N/A',
          DepartmentIds: doctor.department || [],
          Degree: doctor.education || '',
          Mobile: doctor.phone || '',
          Email: doctor.email || '',
          JoiningDate: doctor.joining_date || '',
          adhar_number: doctor.adhar_number || '',
          pan_number: doctor.pan_number || '',
          profile_image: doctor.profile_image || '',
          ProfileImage: doctor.profile_image
            ? `${config.API_URL}uploads/profile_images/user_images/${doctor.profile_image}`
            : "/favicon.png",
          created_by: doctor.created_by || '',
          FIELD9: '',
        }));

        setDoctors(mappedDoctors);
      } else {
        console.error('Fetch doctors failed:', result.message);
        toast.error(result.message || 'Failed to fetch doctors.', {
          position: "top-center",
          toastId: "fetch-error",
        });
      }
    } catch (error) {
      console.error('Error fetching doctors:', error);
      toast.error('Error fetching doctors.', {
        position: "top-center",
        toastId: "fetch-network-error",
      });
    }
  };

  // Get doctor image
  const getDoctorImage = (index) => {
    const images = [blogimg2, blogimg4, blogimg6, blogimg12, blogimg10, blogimg8];
    return images[index % images.length];
  };

  // Archive doctor
  const onArchiveClick = (doctorId) => {
    if (!hasArchivePermission) {
      // toast.error("You do not have permission to archive doctors.", {
      //   position: "top-center",
      //   toastId: "permission-error",
      // });
      return;
    }

    const handleConfirmArchive = async (id) => {
      try {
        const businessID = localStorage.getItem('BusinessID');
        const response = await fetch(
          `${config.API_URL}move_doctor_to_archive.php?business_id=${businessID}&doctor_id=${id}`,
          { method: 'GET' }
        );
        const result = await response.json();

        if (result.status === 'success') {
          toast.success('Doctor archived successfully.', {
            position: "top-center",
            toastId: "archive-success",
          });
          setDoctors((prevDoctors) => prevDoctors.filter((doctor) => doctor.doctor_id !== id));
        } else {
          toast.error('Failed to archive doctor: ' + result.message, {
            position: "top-center",
            toastId: "archive-error",
          });
        }
      } catch (error) {
        console.error('Error archiving doctor:', error);
        toast.error('Something went wrong! Please try again.', {
          position: "top-center",
          toastId: "archive-network-error",
        });
      }
    };

    toast(
      <CustomToast
        onConfirm={handleConfirmArchive}
        doctorId={doctorId}
      />,
      {
        position: 'top-center',
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: true,
      }
    );
  };

  // Fetch data on mount
  useEffect(() => {
    if (hasViewPermission) {
      fetchDepartments();
    } else {
      console.log("No permission to fetch departments or doctors");
      // toast.error("You do not have permission to view the doctors list.", {
      //   position: "top-center",
      //   toastId: "permission-error",
      // });
    }
  }, [hasViewPermission]);

  // Fetch doctors when departments change
  useEffect(() => {
    if (hasViewPermission && departments.length > 0) {
      fetchDoctors();
    }
  }, [departments, hasViewPermission]);

  // Handle search
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
  };

  // Filter doctors
  const filteredDoctors = doctors.filter((doctor) =>
    (doctor.Name || '').toLowerCase().includes(searchText) ||
    (doctor.Department || '').toLowerCase().includes(searchText) ||
    (doctor.Degree || '').toLowerCase().includes(searchText) ||
    (doctor.Mobile || '').toLowerCase().includes(searchText) ||
    (doctor.Email || '').toLowerCase().includes(searchText) ||
    (doctor.JoiningDate || '').toLowerCase().includes(searchText)
  );

  // Open edit modal
  const openEditModal = (doctor) => {
    setSelectedDoctor(doctor);
    console.log('Doctor department IDs:', doctor.DepartmentIds);

    let departmentIds = [];
    if (typeof doctor.DepartmentIds === 'string') {
      try {
        departmentIds = JSON.parse(doctor.DepartmentIds);
      } catch (error) {
        departmentIds = doctor.DepartmentIds.split(',').map(id => id.trim());
      }
    } else {
      departmentIds = Array.isArray(doctor.DepartmentIds) ? doctor.DepartmentIds : [doctor.DepartmentIds];
    }

    const allDepts = getAllDepartmentsFlat(departments);
    const selectedDept = allDepts.find(dept => departmentIds.includes(String(dept.id)));

    const deptOption = selectedDept
      ? { value: selectedDept.id, label: selectedDept.department_name, originalLabel: selectedDept.department_name }
      : null;

    setFormData({
      full_doctor_name: doctor.Name || '',
      education: doctor.Degree || '',
      email: doctor.Email || '',
      phone: doctor.Mobile || '',
      adhar_number: doctor.adhar_number || '',
      pan_number: doctor.pan_number || '',
      department: selectedDept ? [selectedDept.id] : [],
      department_names: selectedDept ? selectedDept.department_name : '',
      joining_date: doctor.JoiningDate || '',
      profile_image: null,
      doctor_id: doctor.doctor_id || '',
    });

    setFilePreview(
      doctor.profile_image
        ? `${config.API_URL}uploads/profile_images/user_images/${doctor.profile_image}`
        : "/favicon.png"
    );

    setSelectedDepartment(deptOption);
    setShowEditModal(true);
  };

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Filter departments for search
  const filterDepartments = (depts, term) => {
    if (!term) return depts;

    return depts
      .map((dept) => {
        const matchesSelf = dept.department_name.toLowerCase().includes(term.toLowerCase());
        const children = dept.children ? filterDepartments(dept.children, term) : [];

        if (matchesSelf || children.length > 0) {
          return { ...dept, children };
        }
        return null;
      })
      .filter(Boolean);
  };

  // Render department options
  const renderDepartmentOptions = (depts, level = 0) => {
    let options = [];

    depts.forEach((dept) => {
      options.push({
        value: dept.id,
        label: `${'—'.repeat(level)} ${dept.department_name}`,
        originalLabel: dept.department_name,
      });

      if (dept.children && dept.children.length > 0) {
        options = [...options, ...renderDepartmentOptions(dept.children, level + 1)];
      }
    });

    return options;
  };

  // Get dynamic options for select
  const getDynamicOptions = (inputValue) => {
    const trimmedInput = inputValue.trim();
    const filteredDepts = trimmedInput ? filterDepartments(departments, trimmedInput) : departments;
    const treeOptions = renderDepartmentOptions(filteredDepts);

    const additionalOptions = trimmedInput ? [
      { value: trimmedInput, label: `Create: ${trimmedInput}`, __isNew__: true },
      { value: 'set-child', label: `Set "${trimmedInput}" as child of...`, inputValue: trimmedInput },
    ] : [];

    return [...treeOptions, ...additionalOptions];
  };

  // Handle department change
  const handleDepartmentChange = async (selectedOption) => {
    if (!selectedOption) {
      setSelectedDepartment(null);
      setFormData((prev) => ({
        ...prev,
        department: [],
        department_names: '',
      }));
      return;
    }

    if (selectedOption.__isNew__) {
      const newDept = await addDepartment(selectedOption.value);
      if (newDept) {
        setSelectedDepartment({ value: newDept.id, label: newDept.department_name });
        setFormData((prev) => ({
          ...prev,
          department: [newDept.id],
          department_names: newDept.department_name,
        }));
      }
      setNewDeptName('');
    } else if (selectedOption.value === 'set-child') {
      setNewDeptName(selectedOption.inputValue);
      setPotentialParentDept(null);
      setShowParentDeptSelector(true);
    } else {
      setSelectedDepartment(selectedOption);
      setFormData((prev) => ({
        ...prev,
        department: [selectedOption.value],
        department_names: selectedOption.originalLabel || selectedOption.label,
      }));
    }
  };

  // Handle parent department selection
  const handleParentDeptSelect = async () => {
    if (!potentialParentDept) {
      toast.error('Please select a parent department', {
        position: "top-center",
        toastId: "parent-dept-error",
      });
      return;
    }

    const newDept = await addDepartment(newDeptName, potentialParentDept.value);
    if (newDept) {
      setSelectedDepartment({ value: newDept.id, label: newDept.department_name });
      setFormData((prev) => ({
        ...prev,
        department: [newDept.id],
        department_names: newDept.department_name,
      }));
      toast.success(`Added ${newDeptName} as a child of ${potentialParentDept.originalLabel || potentialParentDept.label}`, {
        position: "top-center",
        toastId: "add-child-dept-success",
      });
    }

    setShowParentDeptSelector(false);
    setPotentialParentDept(null);
    setNewDeptName('');
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        profile_image: file,
      }));
      setFilePreview(URL.createObjectURL(file));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const businessID = localStorage.getItem('BusinessID');
      if (!businessID) {
        toast.error('Business ID is missing', {
          position: "top-center",
          toastId: "business-id-error",
        });
        return;
      }

      if (!formData.education) {
        toast.error('Degree is required', {
          position: "top-center",
          toastId: "validation-error",
        });
        return;
      }
      if (!formData.department.length) {
        toast.error('Department is required', {
          position: "top-center",
          toastId: "validation-error",
        });
        return;
      }
      if (!formData.joining_date) {
        toast.error('Joining date is required', {
          position: "top-center",
          toastId: "validation-error",
        });
        return;
      }

      const updatedData = {
        doctor_id: formData.doctor_id,
        business_id: businessID,
        doctor_name: formData.full_doctor_name,
        education: formData.education,
        email: formData.email,
        phone: formData.phone,
        Aadhaar_number: formData.adhar_number,
        pan_number: formData.pan_number,
        joining_date: formData.joining_date,
        department: formData.department,
      };

      const formDataToSend = new FormData();
      Object.keys(updatedData).forEach((key) => {
        if (key === 'department') {
          formDataToSend.append(key, JSON.stringify(updatedData[key]));
        } else {
          formDataToSend.append(key, updatedData[key]);
        }
      });

      if (formData.profile_image instanceof File) {
        formDataToSend.append('profile_image', formData.profile_image);
      }

      const response = await fetch(`${config.API_URL}update_doctor.php`, {
        method: 'POST',
        body: formDataToSend,
      });

      const result = await response.json();
      if (result.status === 'success') {
        toast.success('Doctor updated successfully', {
          position: "top-center",
          toastId: "update-success",
        });
        setShowEditModal(false);
        await fetchDepartments();
        await fetchDoctors();
      } else {
        toast.error(result.message || 'Failed to update doctor', {
          position: "top-center",
          toastId: "update-error",
        });
      }
    } catch (error) {
      console.error('Error updating doctor:', error);
      toast.error('Failed to update doctor', {
        position: "top-center",
        toastId: "update-network-error",
      });
    }
  };

  // Custom filter for select
  const customFilterOption = (option, rawInput) => {
    const input = rawInput.toLowerCase().trim();
    if (option.data.__isNew__ && option.data.value.toLowerCase() === input) {
      return true;
    }
    if (option.data.value === 'set-child' && input) {
      return true;
    }
    return option.data.originalLabel
      ? option.data.originalLabel.toLowerCase().includes(input)
      : option.label.toLowerCase().includes(input);
  };

  // Table columns
  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      render: (text, record) => (
        <h2 className="profile-image">
          <Link to="#" className="avatar avatar-sm me-2">
            <img className="avatar-img rounded-circle" src={record.ProfileImage} alt="User Image" />
          </Link>
          <Link to="#">{record.Name}</Link>
        </h2>
      ),
      sorter: (a, b) => (a.Name || '').length - (b.Name || '').length,
    },
    {
      title: 'Department',
      dataIndex: 'Department',
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => (a.Department || '').length - (b.Department || '').length,
    },
    {
      title: 'Degree',
      dataIndex: 'Degree',
      sorter: (a, b) => (a.Degree || '').length - (b.Degree || '').length,
    },
    {
      title: 'Mobile',
      dataIndex: 'Mobile',
      sorter: (a, b) => (a.Mobile || '').length - (b.Mobile || '').length,
      render: (text, record) => <Link to="#">{record.Mobile}</Link>,
    },
    {
      title: 'Email',
      dataIndex: 'Email',
      sorter: (a, b) => (a.Email || '').length - (b.Email || '').length,
    },
    {
      title: 'Joining Date',
      dataIndex: 'JoiningDate',
      sorter: (a, b) => (a.JoiningDate || '').length - (b.JoiningDate || '').length,
    },
    {
      title: '',
      dataIndex: 'FIELD8',
      render: (text, record) => (
        <div className="text-end">
          <div className="dropdown dropdown-action">
            <Link
              to="#"
              className="action-icon dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-end">
              <button
                className="dropdown-item"
                onClick={() => openEditModal(record)}
              >
                <i className="far fa-edit me-2" />
                Edit
              </button>
              {hasArchivePermission && (
                <button
                  className="dropdown-item"
                  onClick={() => onArchiveClick(record.doctor_id)}
                >
                  <i className="fas fa-archive me-2" />
                  Archive
                </button>
              )}
            </div>
          </div>
        </div>
      ),
    },
  ];

  // Permission denied UI
  if (!hasViewPermission) {
    return (
      <div>
        <BusinessHeader />
        <SidebarAdmin
          id="menu-item1"
          id1="menu-items1"
          activeClassName="doctor-list"
        />
        <div className="page-wrapper">
          <div className="content">
            <div className="alert alert-fill alert-danger alert-icon">
              <FeatherIcon icon="cross-circle" />
              <strong>Access Denied</strong>! You do not have permission to view the doctors list.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />
      <BusinessHeader />
      <SidebarAdmin id="menu-item1" id1="menu-items1" activeClassName="doctor-list" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Doctors</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Doctors List</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Doctors List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form onSubmit={(e) => e.preventDefault()}>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search here"
                                  value={searchText}
                                  onChange={handleSearch}
                                />
                                <Link className="btn">
                                  <img src={searchnormal} alt="#" />
                                </Link>
                              </form>
                            </div>
                            <div className="add-group">
                              <Link to="/add-doctor" className="btn btn-primary add-pluss ms-2">
                                <img src={plusicon} alt="#" />
                              </Link>
                              <Link to="#" className="btn btn-primary doctor-refresh ms-2" onClick={fetchDoctors}>
                                <img src={refreshicon} alt="#" />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <Link to="#" className="me-2">
                          <img src={pdficon} alt="#" />
                        </Link>
                        <Link to="#" className="me-2">
                          <img src={pdficon3} alt="#" />
                        </Link>
                        <Link to="#">
                          <img src={pdficon4} alt="#" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive doctor-list">
                    <Table
                      pagination={{
                        total: filteredDoctors.length,
                        showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        onShowSizeChange: onShowSizeChange,
                        itemRender: itemRender,
                      }}
                      columns={columns}
                      dataSource={filteredDoctors}
                      rowSelection={rowSelection}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Edit Doctor Modal */}
        <div
          className={`modal fade ${showEditModal ? 'show d-block' : ''}`}
          id="editDoctorModal"
          role="dialog"
          style={{ display: showEditModal ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Doctor</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>Doctor Details</h4>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4">
                      <div className="form-group local-forms">
                        <label>
                          Name <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="full_doctor_name"
                          value={formData.full_doctor_name}
                          onChange={handleInputChange}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4">
                      <div className="form-group local-forms">
                        <label>
                          Degree <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="education"
                          value={formData.education}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4">
                      <div className="form-group local-forms">
                        <label>
                          Email <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4">
                      <div className="form-group local-forms">
                        <label>
                          Phone <span className="login-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4">
                      <div className="form-group local-forms">
                        <label>Aadhaar Number</label>
                        <input
                          className="form-control"
                          type="text"
                          name="adhar_number"
                          value={formData.adhar_number}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4">
                      <div className="form-group local-forms">
                        <label>PAN Number</label>
                        <input
                          className="form-control"
                          type="text"
                          name="pan_number"
                          value={formData.pan_number}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-6 col-md-6 col-xl-6">
                      <div className="form-group local-forms">
                        <label>
                          Department <span className="login-danger">*</span>
                        </label>
                        {departments.length > 0 ? (
                          <CreatableSelect
                            value={selectedDepartment}
                            onChange={handleDepartmentChange}
                            options={getDynamicOptions(currentInputValue)}
                            onInputChange={(value) => setCurrentInputValue(value)}
                            filterOption={customFilterOption}
                            styles={{
                              control: (base) => ({
                                ...base,
                                borderColor: 'rgba(46, 55, 164, 0.1)',
                                borderRadius: '10px',
                                minHeight: '45px',
                                '&:hover': { borderColor: 'rgba(46, 55, 164, 0.1)' },
                              }),
                              option: (base, state) => ({
                                ...base,
                                whiteSpace: 'pre-wrap',
                                paddingLeft: `${10 + (state.data.label.match(/—/g) || []).length * 10}px`,
                                fontFamily: 'monospace',
                                fontSize: '14px',
                                backgroundColor: state.isSelected ? '#2e37a4' : state.isFocused ? '#f0f0f0' : 'white',
                                color: state.isSelected ? 'white' : 'black',
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                            placeholder="Select or type a department"
                            isClearable
                            isSearchable
                            noOptionsMessage={() => departments.length === 0 ? 'No departments available. Create one first.' : 'Type to create or select a department'}
                          />
                        ) : (
                          <p>Loading departments...</p>
                        )}
                      </div>
                    </div>
                    <div className="col-6 col-md-6 col-xl-6">
                      <div className="form-group local-forms cal-icon">
                        <label>
                          Joining Date <span className="login-danger">*</span>
                        </label>
                        <DatePicker
                          className="form-control datetimepicker"
                          onChange={(date, dateString) =>
                            setFormData((prev) => ({
                              ...prev,
                              joining_date: dateString,
                            }))
                          }
                          value={
                            formData.joining_date
                              ? moment(formData.joining_date)
                              : null
                          }
                          suffixIcon={null}
                          format="YYYY-MM-DD"
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="doctor-submit text-end">
                        <button
                          type="submit"
                          className="btn btn-primary submit-form me-2"
                        >
                          Update
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary cancel-form"
                          onClick={() => setShowEditModal(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Parent Department Selector Modal */}
        {showParentDeptSelector && (
          <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Select Parent Department for <strong>{newDeptName}</strong></h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowParentDeptSelector(false)}
                  />
                </div>
                <div className="modal-body">
                  {departments.length > 0 ? (
                    <CreatableSelect
                      value={potentialParentDept}
                      onChange={(selected) => {
                        setPotentialParentDept(selected);
                      }}
                      options={renderDepartmentOptions(departments)}
                      filterOption={customFilterOption}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: 'rgba(46, 55, 164, 0.1)',
                          borderRadius: '10px',
                          minHeight: '45px',
                          '&:hover': { borderColor: 'rgba(46, 55, 164, 0.1)' },
                        }),
                        option: (base, state) => ({
                          ...base,
                          whiteSpace: 'pre-wrap',
                          paddingLeft: `${10 + (state.data.label.match(/—/g) || []).length * 10}px`,
                          fontFamily: 'monospace',
                          fontSize: '14px',
                          backgroundColor: state.isSelected ? '#2e37a4' : state.isFocused ? '#f0f0f0' : 'white',
                          color: state.isSelected ? 'white' : 'black',
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      placeholder="Select a parent department"
                      isClearable
                      isSearchable
                      noOptionsMessage={() => 'No departments available'}
                    />
                  ) : (
                    <p>No departments available. Please create a department first.</p>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowParentDeptSelector(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!potentialParentDept}
                    onClick={handleParentDeptSelect}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DoctorList;